import { render, staticRenderFns } from "./OauthPage.vue?vue&type=template&id=0b2f8d5c&scoped=true"
import script from "./OauthPage.vue?vue&type=script&lang=js"
export * from "./OauthPage.vue?vue&type=script&lang=js"
import style0 from "./OauthPage.vue?vue&type=style&index=0&id=0b2f8d5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2f8d5c",
  null
  
)

export default component.exports